import { useMemo } from 'react';
import { generatePath } from 'react-router-dom';

import { useUserContext } from 'src/components/app/context/UserContext';
import useGlobalSurvey from 'src/components/myFollowUp/hooks/useGlobalSurvey';

export const FETCHING_GLOBAL_SURVEY = 'loading-global-survey' as const;
export type GlobalSurveyIsLoading = typeof FETCHING_GLOBAL_SURVEY;

const useGenerateWidgetEndpoint = (
  apiPath: string,
  widgetId?: number,
): string | GlobalSurveyIsLoading => {
  const { currentSurvey } = useUserContext();
  const { data: globalSurvey } = useGlobalSurvey(!currentSurvey?.id);

  const surveyId = useMemo(
    // If currentSurvey is undefined, it means we're not within a survey and
    //  should use the global one instead.
    () => currentSurvey?.id ?? globalSurvey?.id,
    [currentSurvey, globalSurvey],
  );

  return useMemo(
    () =>
      surveyId
        ? generatePath(apiPath, {
            surveyId: surveyId,
            widgetId: widgetId,
          })
        : FETCHING_GLOBAL_SURVEY,
    [apiPath, surveyId, widgetId],
  );
};

export default useGenerateWidgetEndpoint;
